import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';

// eslint-disable-next-line
import style from './_style.css';

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function getSuggestions(dictionary, value) {
    const escapedValue = escapeRegexCharacters(value.trim());
    if (escapedValue === '') {
        return [];
    }
    const regex = new RegExp('^' + escapedValue, 'i');
    return dictionary.filter((language) => regex.test(language.nombre.toUpperCase()));
}

function getSuggestionValue(suggestion) {
    return suggestion.nombre.toUpperCase();
}

function renderSuggestion(suggestion) {
    return <span>{suggestion.nombre}</span>;
}

class Auto extends Component {
    state = {
        value: this.props.initialValue ? this.props.initialValue : '',
        suggestions: [],
    };

    onChange = (event, { newValue, method }) => {
        this.props.onChange(newValue);
        this.setState({
            value: newValue,
        });
    };

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: getSuggestions(this.props.dictionary, value),
        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };

    static getDerivedStateFromProps(props, state) {
        if (props.initialValue !== state.value) {
            state.value = props.initialValue;
            return state;
        }
        return null;
    }

    render() {
        const { value, suggestions } = this.state;
        const inputProps = {
            placeholder: this.props.placeholder,
            value,
            onChange: this.onChange,
        };
        const error = !value;

        return (
            <div
                className={error ? 'flex_full_column react-autosuggest_error' : 'flex_full_column'}
            >
                <span className="flex_auto_row react-autosuggest__placeholder">
                    {value && this.props.placeholder}
                </span>
                <Autosuggest
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    getSuggestionValue={getSuggestionValue}
                    renderSuggestion={renderSuggestion}
                    inputProps={inputProps}
                    className="upper"
                />
                <span className="flex_auto_row react-autosuggest__placeholder">
                    {!value && this.props.isRequired}
                </span>
            </div>
        );
    }
}

export default Auto;



// WEBPACK FOOTER //
// ./src/components/inputs/Auto.js